export enum LoyaltyRewardMiniCardVariant {
  FREE_SPINS = "free_spins",
  NOMINAL = "nominal",
  CASHBACK_DAILY = "cashbackDaily",
  CASHBACK_WEEKLY = "cashbackMonthly",
  CASHBACK_MONTHLY = "cashbackWeekly",
}

export type LoyaltyRewardMiniCardProps = {
  value: string;
  variant: LoyaltyRewardMiniCardVariant;
  primaryTitle?: boolean;
  canGet?: boolean;
  image?: string;
  rankName?: string;
  handleClick?: () => void;
};

export type LoyaltyRewardMiniCardPropsWithId = LoyaltyRewardMiniCardProps & {
  id: string;
};
